export default function OrdemServico(){
    return (
        "Ordem de serviço"

    );

}